import { Ikon } from 'assets/icons';
import { Button } from 'components/button';
import {
  useFetchRecipes,
  useFetchSingleMixture,
  useFetchSingleRecipe
} from 'hooks/recipes/useRecipesHook';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styles from './index.module.css';
import { Loading } from 'components/loading';
import { Toasts } from 'components/toasts';
import { client } from 'utilities/db';
import moment from 'moment';
import { useCountry } from 'contexts/CountryContext';
import { useStore } from 'store';
import { AccessDenied } from 'components/acess-denied';
import { Row } from 'layouts/container';

export const RecipeDetail = ({ onEdit, isMixture, onChangeStep }) => {
  const { id } = useParams();
  const { user, branch } = useStore((state) => state);
  const { formatDate } = useCountry();
  const locationId = user?.brand?.id;
  const branchId = branch?.id;

  const recipePermission = user?.role?.permissions?.find(
    (permission) =>
      permission?.slug === 'recipe_engineering' &&
      permission?.module_slug === 'recipes'
  );

  const { data: recipesData = [] } = useFetchRecipes(branchId, locationId);
  const getRecipeData = recipesData?.find(
    (item) => Number(item?.RecipeModel?.id) === Number(id)
  );

  const {
    data: fetchedRecipe = {},
    isLoading: fetchedRecipeLoading,
    refetch
  } = useFetchSingleRecipe(!isMixture ? id : null);

  console.log('fetchedRecipeLoading', fetchedRecipeLoading, fetchedRecipe);

  const {
    data: fetchedMixture = {},
    isLoading: fetchedMixtureLoading,
    refetch: refetchMixture
  } = useFetchSingleMixture(isMixture ? id : null);

  // console.log('fetchedMixture', fetchedMixture, fetchedMixtureLoading);

  const recipe = fetchedRecipe || {};
  const recipeIngredients = [];
  const productNutrientsDetails = [];

  const { mixture_name = '', MixtureRecipeModel = [] } = fetchedMixture || {};

  const recipe_name = recipe?.recipe_name || '';
  const recipe_update_at = recipe?.updated_at || '';
  const cooking_time = recipe?.cooking_time || '00:00';
  const recipe_cost = recipe?.recipe_cost || 0;
  const no_of_ingredients = recipe?.no_of_ingredients || '';
  const total_servings = recipe?.total_servings || '';
  const steps = recipe?.steps ? JSON.parse(recipe?.steps) : [];

  useEffect(() => {
    if (id) {
      if (isMixture) {
        refetchMixture(id);
        return;
      }
      refetch(id);
    }
  }, [id]);

  const enableForMenu = async () => {
    try {
      let bool = fetchedRecipe?.recipe?.add_nutrition_to_menu;
      const response = await client.post(
        `recipe/addNutritionToMenu/${fetchedRecipe?.recipe?.id}`,
        {
          add_nutrition_to_menu: !bool
        }
      );
      refetch();
      Toasts.success(
        `${
          bool
            ? 'Nutrition facts removed from menu'
            : 'Nutrition facts added to menu'
        }`
      );
    } catch (error) {
      console.log('error', error);
      Toasts.error('Something went wrong');
    }
  };

  if (recipePermission?.access?.read === false) {
    return <AccessDenied />;
  }

  if (isMixture && !fetchedMixture?.id) {
    return (
      <div className={`loading_full`}>
        <Loading />
      </div>
    );
  }

  if (isMixture && fetchedMixture?.id) {
    return (
      <>
        <article className={styles.article}>
          <div className="flex item_space_btn">
            <div>
              <Row alignItems={'center'} gap={8}>
                <div>
                  <Button
                    onClick={() => {
                      onChangeStep(1);
                    }}
                    style={{
                      whiteSpace: 'nowrap',
                      padding: '10px 10px',
                      width: 'auto',
                      background: '#FFFFFF',
                      boxShadow: '0px 0px 4px #D1D1D3',
                      borderRadius: '6px',
                      gap: '4px',
                      fontWeight: '500',
                      color: '#474747',
                      height: 'auto'
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      width={16}
                      height={16}
                      strokeWidth="1.5"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                      />
                    </svg>
                  </Button>
                </div>
                <div>
                  <h1>
                    <strong>Recipe Engineering</strong>
                  </h1>
                  <h5 className="mt_4">Manage and create recipes</h5>
                </div>
              </Row>
            </div>
            <div>
              <Button
                onClick={() => onEdit(fetchedMixture)}
                type="button"
                label={'Edit'}
                color={'bg-button'}
              />
            </div>
          </div>
          <h4>
            <span className="ff_semi">{mixture_name}</span>
          </h4>
          <div className={styles.ingredients}>
            <div className={styles.slider}>
              <div
                className={styles.sliderBr}
                style={{ width: `calc(175px * ${MixtureRecipeModel?.length})` }}
              >
                {MixtureRecipeModel?.map((item, index) => (
                  <div key={index} className={styles.ingCard}>
                    <div>
                      <div className={styles.ingCardIcon}>
                        {item?.ProductModel?.product_name
                          ?.split(' ')?.[0]
                          ?.charAt(0)}
                        {item?.ProductModel?.product_name
                          ?.split(' ')?.[1]
                          ?.charAt(0)}
                      </div>
                    </div>
                    <div>
                      <h5>{item?.ProductModel?.product_name}</h5>
                    </div>
                    <div
                      className={`${styles.badge} ${
                        item?.type === 'raw' ||
                        item?.ingredient_type?.toLowerCase() === 'raw'
                          ? styles.badge1
                          : styles.badge2
                      }`}
                    >
                      {item?.ingredient_type?.toLowerCase()}
                    </div>
                    <div className={styles.quantity}>
                      <div>Quantity</div>
                      <div className={styles.quantity_dot}></div>
                      <div>{item?.quantity}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </article>
      </>
    );
  }

  if (fetchedRecipeLoading || !recipe?.menuItem?.id) {
    return (
      <div className={`loading_full`}>
        <Loading />
      </div>
    );
  }

  return (
    <>
      <article className={styles.article}>
        <div className="flex item_space_btn">
          <div>
            <h1>
              <strong>Recipe Engineering</strong>
            </h1>
            <h5 className="mt_4">Manage and create recipes</h5>
          </div>
          <div>
            <Button
              onClick={() => onEdit(fetchedRecipe)}
              type="button"
              label={'Edit'}
              color={'bg-button'}
              disabled={recipePermission?.access?.update === false}
            />
          </div>
        </div>
        <h4>
          <span className="ff_semi">{recipe_name}</span>
        </h4>
        <div className={styles.r1Bx}>
          <div>
            <div className={styles.profileIcon}>
              {getRecipeData?.MenuItemModel?.menu_item_name
                ?.split(' ')?.[0]
                ?.charAt(0)}
              {getRecipeData?.MenuItemModel?.menu_item_name
                ?.split(' ')?.[1]
                ?.charAt(0)}
            </div>
          </div>
          <div className={styles.column1}>
            <div>
              <div className={styles.r1Item1}>
                <label>Last use</label>
                <div className={styles.value}>{formatDate(recipe_update_at)}</div>
              </div>
            </div>
            <div className={styles.itemsFlex1}>
              <div className={styles.r1Item2}>
                <label>No of ingredients</label>
                <div className={styles.value}>{no_of_ingredients}</div>
              </div>
              <div className={styles.r1Item2}>
                <label>Cooking time</label>
                <div className={styles.value}>{cooking_time}</div>
              </div>
            </div>
          </div>
          <div className={styles.itemsFlex1}>
            <div className={styles.column1}>
              <div>
                <div className={styles.itemIcon}>
                  <Ikon name={`bag-cart`} />
                </div>
              </div>
              <div className={styles.r1Item2}>
                <label>Total cost</label>
                <div className={styles.value}>${recipe_cost}</div>
              </div>
            </div>
            <div className={styles.column1}>
              <div>
                <div className={styles.itemIcon}>
                  <Ikon name={`bag-cart`} />
                </div>
              </div>
              <div className={styles.r1Item2}>
                <label>Calories</label>
                <div className={styles.value}>
                  {getRecipeData?.MenuItemModel?.calories}
                </div>
              </div>
            </div>
            <div className={styles.column1}>
              <div>
                <div className={styles.itemIcon}>
                  <Ikon name={`bag-cart`} />
                </div>
              </div>
              <div className={styles.r1Item2}>
                <label>Total servings</label>
                <div className={styles.value}>{total_servings}</div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="shadow_box1">
          <div className={styles.recipeDetailFlex}>
            <div className={styles.flexLayer1}>
              <div>
                <div className={styles.label1}>Allergens</div>
                <div className={styles.value1}>
                  {JSON.stringify(allergens)?.replace(/[\[\]'",]+/g, ' ')}
                </div>
              </div>
              <div>
                <div className={styles.label1}>
                  <span>Health score</span>
                  <span>
                    <Ikon name="suport" />
                  </span>
                  <span
                    onClick={enableForMenu}
                    style={{
                      cursor: 'pointer'
                    }}
                  >
                    {fetchedRecipe?.recipe?.add_nutrition_to_menu
                      ? 'Remove from Menu'
                      : 'Add to Menu'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className={styles.ingredients}>
          <div className={styles.slider}>
            <div
              className={styles.sliderBr}
              style={{ width: `calc(175px * ${recipeIngredients?.length})` }}
            >
              {recipeIngredients?.map((item, index) => (
                <div key={index} className={styles.ingCard}>
                  <div>
                    <div className={styles.ingCardIcon}>
                      {item?.ProductModel?.product_name
                        ?.split(' ')?.[0]
                        ?.charAt(0) ||
                        item?.MixtureModel?.mixture_name
                          ?.split(' ')?.[0]
                          ?.charAt(0) ||
                        item?.ProductGroupModel?.group_name
                          ?.split(' ')?.[0]
                          ?.charAt(0)}
                      {item?.ProductModel?.product_name
                        ?.split(' ')?.[1]
                        ?.charAt(0) ||
                        item?.MixtureModel?.mixture_name
                          ?.split(' ')?.[1]
                          ?.charAt(0) ||
                        item?.ProductGroupModel?.group_name
                          ?.split(' ')?.[1]
                          ?.charAt(0)}
                    </div>
                  </div>
                  <div>
                    <h5>
                      {item?.ProductModel?.product_name ||
                        item?.MixtureModel?.mixture_name ||
                        item?.ProductGroupModel?.group_name}
                    </h5>
                  </div>
                  <div
                    className={`${styles.badge} ${
                      item.type === 'raw' ||
                      item?.ingredient_type?.toLowerCase() === 'raw'
                        ? styles.badge1
                        : styles.badge2
                    }`}
                  >
                    {item?.ingredient_type?.toLowerCase()}
                  </div>
                  <div className={styles.quantity}>
                    <div>Quantity</div>
                    <div className={styles.quantity_dot}></div>
                    <div>{item?.quantity}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.grid}>
          <div>
            <h4>Steps for a recipe</h4>
            <div className={styles.stepList}>
              {steps?.map((item, index) => (
                <div className={styles.stepCard} key={index}>
                  <div></div>
                  <div>Step {index + 1}:</div>
                  <div>{item?.content}</div>
                </div>
              ))}
            </div>
            {/* {steps?.map((item) => (
              <div className={`${styles.accordionStep} mt_10`} key={item.step}>
                <TempAccordion title={`Step ${item?.step}`}>
                  {item?.content}
                </TempAccordion>
              </div>
            ))} */}
          </div>
          <div>
            <h4>Nutritional facts</h4>
            <div className={styles.nutList}>
              {productNutrientsDetails?.map((item, i) => (
                <div key={i} className={styles.nutCard}>
                  <div></div>
                  <div>
                    <div>{item?.nutrientName}</div>
                    <div>
                      {item?.value} {item?.unitName}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </article>
    </>
  );
};
